/* DRP Media — Global JS */
'use strict';

/* ---- Mobile nav ---- */
(function () {
  var btn = document.getElementById('hamburger-btn');
  var nav = document.getElementById('mobile-nav');
  var overlay = document.getElementById('mobile-nav-overlay');
  var closeBtn = document.getElementById('mobile-nav-close');
  if (!btn || !nav) return;

  function open() {
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn && closeBtn.focus();
  }

  function close() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    btn.focus();
  }

  btn.addEventListener('click', open);
  closeBtn && closeBtn.addEventListener('click', close);
  overlay && overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
  });
})();

/* ---- Cart count refresh ---- */
(function () {
  function updateCartCount(count) {
    var el = document.getElementById('cart-count');
    if (!el) return;
    el.textContent = count;
    if (count > 0) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  /* Listen for custom cart:updated events emitted by sections */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.count === 'number') {
      updateCartCount(e.detail.count);
    }
  });

  /* Patch fetch to catch add-to-cart calls.
     Clone the response before returning so that any caller that reads the body
     (e.g. customizer.js calling r.json()) gets the original stream, while this
     interceptor gets a separate stream for the background /cart.js refresh. */
  var origFetch = window.fetch;
  window.fetch = function () {
    return origFetch.apply(this, arguments).then(function (resp) {
      if (resp.url && resp.url.includes('/cart/add') && resp.ok) {
        // Only refresh count on success; don't fire a spurious /cart.js on 422s
        origFetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartCount(cart.item_count); })
          .catch(function () { /* ignore background refresh errors */ });
      }
      return resp;
    });
  };
})();

/* ---- Announcement bar dismiss ---- */
(function () {
  var bar = document.getElementById('announcement-bar');
  var closeBtn = document.getElementById('announcement-close');
  if (!bar || !closeBtn) return;

  var key = 'drp_announcement_dismissed_' + (bar.dataset.id || '1');
  if (sessionStorage.getItem(key)) {
    bar.remove();
    return;
  }

  closeBtn.addEventListener('click', function () {
    bar.style.transition = 'max-height 300ms ease, opacity 300ms ease';
    bar.style.maxHeight = bar.offsetHeight + 'px';
    requestAnimationFrame(function () {
      bar.style.maxHeight = '0';
      bar.style.opacity = '0';
    });
    bar.addEventListener('transitionend', function () {
      bar.remove();
    }, { once: true });
    sessionStorage.setItem(key, '1');
  });
})();

/* ---- Back to top ---- */
(function () {
  var btn = document.createElement('button');
  btn.id = 'back-to-top';
  btn.className = 'back-to-top';
  btn.setAttribute('aria-label', 'Back to top');
  btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 12V4M3 9l5-5 5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  document.body.appendChild(btn);

  window.addEventListener('scroll', function () {
    btn.classList.toggle('is-visible', window.scrollY > 400);
  }, { passive: true });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

/* ---- Scroll reveal ---- */
(function () {
  if (!window.IntersectionObserver) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(function (el) {
    observer.observe(el);
  });
})();

/* ---- Counter animation ---- */
(function () {
  if (!window.IntersectionObserver) return;
  function animateCounter(el) {
    var raw = el.dataset.target || '0';
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';
    var target = parseInt(raw.replace(/\D/g, ''), 10);
    if (isNaN(target)) { el.textContent = prefix + raw + suffix; return; }
    var current = 0;
    var step = Math.max(1, Math.ceil(target / 60));
    var timer = setInterval(function () {
      current += step;
      if (current >= target) { current = target; clearInterval(timer); }
      el.textContent = prefix + current + suffix;
    }, 20);
  }
  var cObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        cObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('[data-counter]').forEach(function (el) {
    cObs.observe(el);
  });
})();

/* ---- Cursor glow on hero ---- */
(function () {
  var hero = document.querySelector('.hero');
  if (!hero || window.matchMedia('(hover: none)').matches) return;
  hero.classList.add('hero-cursor-glow');
  hero.addEventListener('mousemove', function (e) {
    var rect = hero.getBoundingClientRect();
    hero.style.setProperty('--hx', (e.clientX - rect.left) + 'px');
    hero.style.setProperty('--hy', (e.clientY - rect.top) + 'px');
  }, { passive: true });
})();

/* ---- Add to cart form ---- */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();

    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = btn.dataset.addingText || 'Adding…';
    }

    var data = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { count: cart.item_count } })
        );
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.dataset.addedText || 'Added!';
          setTimeout(function () {
            btn.textContent = btn.dataset.addText || 'Add to Cart';
          }, 2000);
        }
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.dataset.addText || 'Add to Cart';
        }
      });
  });
})();
